import AppTheme from './lib/theme';
import Dashboard from './pages/dashboard/Dashboard';
import EditUser from './pages/onboarding/EditUser';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import HealthCheck from './pages/health/HealthCheck';
import Login from './pages/login/Login';
import ViewProjectsPage from './pages/onboarding/ViewProjectsPage';
import OnboardingHome from './pages/onboarding/OnboardingHome';
import OnboardingLayout from './pages/onboarding/OnboardingLayout';
import PageNotFound from './components/pageNotFound/PageNotFound';
import PrivateRoute from './utils/route/PrivateRoute';
import RequirePermission from './utils/route/RequirePermission';
import {
  projectCreatePermission,
  projectEditPermission,
  userOnboardingPermission,
} from './utils/route/routePermissions';
import ProjectOnboarding from './pages/onboarding/ProjectOnboarding';
import SnackBar from './components/snackbar/SnackBar';
import UserOnboarding from './pages/onboarding/UserOnboarding';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { pageRoutes } from './constants/routes';

function LegacyDashboardRedirect() {
  const { projectId, runId } = useParams<{
    projectId: string;
    runId: string;
  }>();
  const p = Number(projectId);
  const r = Number(runId);
  if (!Number.isFinite(p) || p <= 0 || !Number.isFinite(r) || r <= 0) {
    return <Navigate to={pageRoutes.onboarding} replace />;
  }
  return <Navigate to={pageRoutes.dashboardProjectRun(p, r)} replace />;
}

const rootStyle = {
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
  gridTemplateColumns: '1fr',
  minHeight: '100vh',
};

const appBodyStyle = {
  display: 'flex',
  flexDirection: 'column' as 'column',
  maxWidth: '100vw',
  overflowY: 'hidden' as 'hidden',
};

function App() {
  return (
    <AppTheme>
      <div className="rpt" style={rootStyle}>
        <BrowserRouter>
          <AuthProvider>
            <Header />
            <div className="app-body" style={appBodyStyle}>
            <Routes>
              <Route path={pageRoutes.rootPath} element={<Login />} />
              <Route
                path={pageRoutes.dashboard}
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard/project/:projectId/run/:runId"
                element={
                  <PrivateRoute>
                    <LegacyDashboardRedirect />
                  </PrivateRoute>
                }
              />
              <Route
                path={pageRoutes.health}
                element={
                  <PrivateRoute>
                    <HealthCheck />
                  </PrivateRoute>
                }
              />
              <Route
                path={pageRoutes.onboarding}
                element={
                  <PrivateRoute>
                    <OnboardingLayout />
                  </PrivateRoute>
                }
              >
                <Route index element={<OnboardingHome />} />
                <Route
                  path="user"
                  element={
                    <RequirePermission config={userOnboardingPermission}>
                      <UserOnboarding />
                    </RequirePermission>
                  }
                />
                <Route
                  path="project"
                  element={
                    <RequirePermission config={projectCreatePermission}>
                      <ProjectOnboarding />
                    </RequirePermission>
                  }
                />
                <Route
                  path="projects/:projectId"
                  element={
                    <RequirePermission config={projectEditPermission}>
                      <ProjectOnboarding />
                    </RequirePermission>
                  }
                />
                <Route path="projects" element={<ViewProjectsPage />} />
                <Route path="edit-user" element={<EditUser />} />
              </Route>
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>
          <Footer />
          <SnackBar />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </AppTheme>
  );
}

export default App;
